import type { LearningTopicWithProgress } from '@/types'

/** Must match `MAX_PENDING_TOPICS_PER_USER` in `services/app/api/v1/endpoints/learn.py`. */
export const MAX_CONCURRENT_TOPIC_GENERATIONS = 10

/** Tooltip when another job (or non-job topic) still has lessons generating. */
export const LEARN_ALL_BLOCKED_WHILE_GENERATING_TOOLTIP =
  "We're still building lessons for you. When those finish, you can add more from this job."

function isPendingOrGenerating(status: LearningTopicWithProgress['generation_status']): boolean {
  return status === 'pending' || status === 'generating'
}

export function countPendingOrGeneratingTopics(
  items: LearningTopicWithProgress[] | undefined,
): number {
  if (!items?.length) return 0
  return items.filter((t) => isPendingOrGenerating(t.generation_status)).length
}

export function hasAnyGeneratingTopics(items: LearningTopicWithProgress[] | undefined): boolean {
  return countPendingOrGeneratingTopics(items) > 0
}

export function jobHasGeneratingTopics(
  jobPostingId: number,
  items: LearningTopicWithProgress[] | undefined,
): boolean {
  if (!items?.length) return false
  return items.some(
    (t) => t.job_posting_id === jobPostingId && isPendingOrGenerating(t.generation_status),
  )
}

export function jobHasLearningTopics(
  jobPostingId: number,
  items: LearningTopicWithProgress[] | undefined,
): boolean {
  if (!items?.length) return false
  return items.some((t) => t.job_posting_id === jobPostingId)
}
